/* template */
<template minapp="mpx" xlang="wxml"><div class="es-train-information"><div class="es-train-information-container"><div class="recommend" v-if="(isRecommendTicket)"><div :style="[(keyTips?'justify-content:space-between':'justify-content:flex-end')] | transRpxStyle" class="recommend-tips"><div class="left" v-if="(keyTips)">{{keyTips}}</div><div class="right"><div class="recommend-checkin">{{defaultCheckIn}}</div></div></div><more-less-guide :guide="(recommendGuide)" :orderDetail="(true)"/><mpx-view @tap="goWarning" class="warning" v-if="(isOnBoard)">利用”买短乘长“恶意逃票属违法行为，情节严重的将被追究刑事责任</mpx-view></div><div class="train-gate-info" v-else-if="(checkIn)"><div class="train-gate-info-left"><mpx-image src="https://ut-static.udache.com/webx/sfc/AukeLGBbJQjkJEsPtVbHT.png" class="train-gate-info-left-icon"/><div class="train-gate-info-left-checkin">{{defaultCheckIn}}</div></div><div class="change" v-if="(isChange)">已改签</div></div><div :style='["display: flex"] | transRpxStyle' class="es-train-information-container-top"><div class="transfer-segment-container" v-if="(cardIndex)"><span class="word">第</span><span class="word number">{{cardIndex}}</span><span class="word">程</span></div><div :class="({'no-detail': noDetail, 'transfer': cardIndex, 'lessbottom': hasSlot() })" :style="[(showDate && !hasSlot() ? {paddingTop: '22px'} : {})] | transRpxStyle" class="info"><slot name="headerSlot"></slot><mpx-image src="https://ut-static.udache.com/webx/sfc/ZnWx-lzsNC0YijiX26bVy.png" :class="(cardIndex && 'transform')" class="train-image"/><div class="day-difference" v-if="(dayDifference > 0)">{{ `+${dayDifference}天` }}</div><div class="es-train-information-item"><div :style="[(showDate ? {marginBottom: '5px', marginTop: '3px'} : {})] | transRpxStyle" class="es-train-info-date" v-if="(showDate)">{{ startTime.date }} {{ startTime.week }}</div><div :style="[(showDate || cardIndex ? {} : {marginTop: '11px'})] | transRpxStyle" class="es-train-info-time">{{ startTime.time }}</div><div class="es-train-station-name">{{ fromStationName }}<div class="station-tag">{{isStartStation ? '始' : '过'}}</div></div></div><div :style="[({paddingTop: '2px', alignItems: 'center', justifyContent: 'center'})] | transRpxStyle" class="es-train-information-item"><div :class="(!cardIndex ? 'es-train-code' : 'es-train-code-date')">{{ trainCode }}<span class="travel-time" v-if="(cardIndex)">{{ travelTime }}</span></div><div :style='["marginTop: 4px"] | transRpxStyle' class="es-train-info-container"><div class="line"></div><mpx-view @tap="onClick" class="es-train-info">时刻表</mpx-view><div class="line"></div></div><div class="travel-time-date" v-if="(!cardIndex)">{{ travelTime }}</div></div><div :style='["text-align: right"] | transRpxStyle' class="es-train-information-item"><div :style="[(showDate ? {marginBottom: '5px', marginTop: '3px'} : {})] | transRpxStyle" class="es-train-info-date" v-if="(showDate)">{{ endTime.date }} {{ endTime.week }}</div><div :style="[(showDate || cardIndex ? {} : {marginTop: '11px'})] | transRpxStyle" class="es-train-info-time">{{ endTime.time }}</div><div :style='["justify-content: flex-end"] | transRpxStyle' class="es-train-station-name"><div class="station-tag">{{isEndStation ? '终' : '过'}}</div>{{ toStationName }}</div></div></div></div></div><slot name="footerSlot"></slot></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m7f4255a4"}'>
  @import '~@/mixins/stylus/color.styl'

  .es-train-information
    // padding 0 10px 14px
    &-container
      background #EAF3FF
      display flex
      border-radius 10px
      position relative
      flex-direction column
      background #338FFF
      .recommend
        padding 16px 16px 10px 16px
        color #FFFFFF
        .recommend-tips
          display flex
          align-items center
          font-weight 800
          margin-bottom 22px
          .left
            min-width 174px
            overflow hidden
            text-overflow ellipsis
            white-space nowrap
            margin-right 8px
            font-weight 800
            font-size 16px
            flex 1
          .right
            align-self flex-end
            max-width 126px
            font-size 14px
        .recommend-checkin
            text-align right
            font-weight 800
            font-size 14px
            display -webkit-box
            -webkit-box-orient vertical
            overflow hidden
            -webkit-line-clamp 2
        .warning
          font-size 10px
          color #ADD2FF
          margin-top 8px
          margin-bottom -2px
          position relative
          &::after
            position absolute
            content ''
            width 4px
            height 4px
            border-top 1px solid
            border-right 1px solid
            position absolute
            top 5px
            right 2px
            transform rotate(45deg)
      .train-gate-info
        display flex
        justify-content space-between
        padding 10px 0 10px 16px
        border-radius 10px 10px 0 0
        font-family PingFangSC-Medium
        font-size 14px
        line-height 14px
        color #fff
        z-index 1
        position relative
        &-left
          display flex
          &-icon
            height 14px
            width 14px
            margin-right 5px
          &-name
            font-family PingFangSC-Regular
            margin-right 9px
        .change
          position absolute
          top 0
          right 0
          width 100px
          height 45px
          display flex
          font-family PingFangSC-Medium
          font-weight 500
          font-size 14px
          flex-direction row-reverse
          padding 10px 16px 0 0
          box-sizing border-box
          background-size contain
          background-image url('https://ut-static.udache.com/webx/sfc/VdAlNyO5aJfgFXS0oRefC.png')
      .day-difference
        position absolute
        right 10px
        top 10px
        font-size 13px
        color #333333
        font-family PingFangSC-Semibold
      .info
        display flex
        flex 1
        justify-content space-between
        padding 22px 16px 25px 16px
        border-radius 10px 10px 0 0
        position relative
        background #EAF3FF
        z-index 2
        &.no-detail
          border-radius 10px
        .train-image
          position absolute
          width 156.5px
          height 55px
          top 32px
          left 50%
          transform  translateX(-50%)
          &.transform
            transform translate(-50%, -10px)
        &.transfer
          border-radius 0 10px 10px 0
        &.lessbottom
          padding-bottom 20px
          padding-top 14px
    .es-train-information-item
      display flex
      flex-direction column
      // justify-content space-between
      min-width 70px
      position relative
      .es-train-info-date, .es-train-info-travel-time
        font-size 13px
        color $train-color-666
      .es-train-info-time
        font-size 32px
        color $train-color-333
        font-weight 500
        font-family Barlow Semi Condensed
        line-height 32px
      .es-train-code
        line-height 20px
        font-size 15px
        color #333
        display flex
        align-items center
        font-family Barlow Semi Condensed
        font-weight 500
        margin-top 5px
      .es-train-code-date
        color #2F497D
        font-size 12px
        font-family PingFangSC-Regular
        line-height 12px
      .travel-time
        margin-left 5px
      .travel-time-date
        font-size 13px
        color #333333
        margin-top 4px
      .es-train-station-name
        font-size 13px
        color #333333
        display flex
        align-items center
        line-height 13px
        margin-top 6px
        .station-tag
          border-radius 3px
          text-align center
          border 0.5px solid #95BCD6
          width 11px
          height 11px
          text-align center
          line-height 12px
          font-size 9px
          color #3B6E8F
          margin 0 2px
      .es-train-info-container
        display flex
        align-items center
        margin-top 10px
      .line
        width 18px
        height 1px
        background #95BCD6
      .es-train-info
        position relative
        width 50px
        height 18px
        color #3B6E8F
        font-size 10px
        border-radius 8px
        text-align center
        line-height 18px
        &:after
          position absolute
          content ''
          width 200%
          height 200%
          box-sizing border-box
          border 1px solid #95BCD6
          transform-origin 0 0
          transform scale(0.5)
          border-radius 12px
          top 0
          left 0
      .es-train-divider
        border-bottom 1px solid #CAD0DA
        width 100%
  .es-train-information-container
    display flex
    flex-direction column
  .es-train-information-container-top
    display flex
    .transfer-segment-container
      display flex
      flex-direction column
      justify-content  center
      font-family PingFang SC
      padding 0 12px
      font-size 12px
      font-weight 400
      text-align center
      color #2F497D
      background #D2E6FF
      border-radius 10px 0 0 10px
      .word
        height 20px
      .number
        margin -5px 0
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m7f4255a4"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex7f4255a4%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex7f4255a4%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m7f4255a4"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index7f4255a4/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'more-less-guide':getComponent(require("../recommend-ticket/more-less-guide.mpx?isComponent&outputPath=components%2Fmore-less-guide0bb010cb%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
